/**
 * The year for which carbon emissions data should be displayed.
 *
 * TODO: Hardcoded to 2025. Revert to dynamic calculation
 * (new Date().getFullYear() - 1) once data availability is reliable.
 */
export const EMISSIONS_DATA_YEAR = 2025;
